import {SenkronRaporCevap, SenkronRaporSatiri} from "@/services/senkronPlanService";
import {raporToplamiHesapla, SabahRaporuToplami} from "@/plugins/uyap-plugin/senkronSabahRaporuMesaji";

/**
 * Sabah raporu görünümlerinin saf yardımcıları (Faz 3, DEV-2968).
 *
 * Toplam hesabı `uyap-plugin/senkronSabahRaporuMesaji`ten YENİDEN KULLANILIR:
 * OS bildirimi ile ekrandaki şerit aynı sayıları göstermeli. İki ayrı toplama
 * yazılsaydı bildirimde "118 senkronlandı" derken şeritte başka bir sayı
 * belirmesi an meselesi olurdu.
 */

export type RaporToplami = SabahRaporuToplami;

export function raporToplami(planlar: Array<SenkronRaporSatiri>): RaporToplami {
    return raporToplamiHesapla(planlar as any);
}

/** Yerel takvim günü, "YYYY-AA-GG" — uç `gun` parametresini bu biçimde istiyor (Y-m-d). */
export function gunDamgasi(tarih: Date = new Date()): string {
    const ay = String(tarih.getMonth() + 1).padStart(2, "0");
    const gun = String(tarih.getDate()).padStart(2, "0");
    return `${tarih.getFullYear()}-${ay}-${gun}`;
}

/**
 * Gün damgasını kaydırır ("2026-08-19", -1 -> "2026-08-18").
 *
 * Gün bileşenleri YEREL `Date` ile kurulur, `Date.parse` ile değil: "2026-08-19"
 * dizesini `new Date(...)`e vermek onu UTC gece yarısı sayar ve UTC+3'te bir gün
 * geriye kayabilir.
 */
export function gunKaydir(gun: string, fark: number): string {
    const parcalar = String(gun).split("-").map((p) => Number(p));
    if (parcalar.length !== 3 || parcalar.some((p) => !Number.isFinite(p))) {
        return gun;
    }
    const tarih = new Date(parcalar[0], parcalar[1] - 1, parcalar[2]);
    tarih.setDate(tarih.getDate() + fark);
    return gunDamgasi(tarih);
}

/** Bugünden ileri gidilmesin: rapor ucu gelecek gün için hep boş döner. */
export function ileriGidilebilirMi(gun: string): boolean {
    return gun < gunDamgasi();
}

/**
 * İşlemler sayfasındaki şeridin tek satırlık özeti.
 * `null` = şerit gösterilmez (o gün koşan plan yok).
 */
export function seritOzeti(rapor: SenkronRaporCevap | null): string | null {
    if (!rapor || !Array.isArray(rapor.planlar) || rapor.planlar.length === 0) return null;

    const toplam = raporToplami(rapor.planlar);
    const parcalar: string[] = [`${toplam.biten}/${toplam.uretilen} dosya senkronlandı`];

    if (toplam.bekleyen > 0) parcalar.push(`${toplam.bekleyen} bekliyor`);
    if (toplam.hatali > 0) parcalar.push(`${toplam.hatali} hatalı`);
    if (toplam.atlananDosya > 0) parcalar.push(`${toplam.atlananDosya} dosya vadesi gelmediği için atlandı`);

    parcalar.push(
        toplam.yuksekOncelikliOneri > 0
            ? `${toplam.yeniOneri} yeni öneri — ${toplam.yuksekOncelikliOneri} yüksek`
            : `${toplam.yeniOneri} yeni öneri`
    );

    return parcalar.join(" · ");
}

/** Şeridin rengi: üretim çökmüş ya da görev hatalıysa uyarı tonu. */
export function seritTonu(rapor: SenkronRaporCevap | null): "info" | "warning" {
    if (!rapor || !Array.isArray(rapor.planlar)) return "info";
    const toplam = raporToplami(rapor.planlar);
    return toplam.hataliPlan > 0 || toplam.hatali > 0 ? "warning" : "info";
}
